import { useQuery } from '@connectrpc/connect-query'

import { generateGitbookSSO } from '@/gen/customer/management/v1/service-CustomerManagementService_connectquery'

export const useGitbookSSO = (location: string) => {
  return useQuery(
    generateGitbookSSO,
    { location },
    {
      staleTime: 0,
      gcTime: 0,
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  )
}
